import { useRef } from "react";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Toaster } from "sonner";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Offer from "@/components/site/Offer";
import Gallery from "@/components/site/Gallery";
import LeadCapture from "@/components/site/LeadCapture";
import Bio from "@/components/site/Bio";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const formRef = useRef(null);
  const scrollToForm = () =>
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <SmoothScroll>
      <Toaster position="top-center" richColors />
      <main data-testid="landing-page" className="bg-bone">
        <Hero onCta={scrollToForm} />
        <Marquee />
        <Manifesto />
        <Offer onCta={scrollToForm} />
        <Gallery />
        <LeadCapture innerRef={formRef} />
        <Bio />
        <Footer onCta={scrollToForm} />
      </main>
    </SmoothScroll>
  );
}
